module.exports = __webpack_public_path__ + "static/media/star-white.fc589caf.png";